<!--
  @Description 数据处理
  @Date 2022-10-25
  @Author liufu
-->
<template>
  <div class="card">
    <!-- 按钮区域 -->
    <div class="buttonContainer">
      <div class="toolbar-dv">
        <toolBarBtn
          :parentData="this"
          :buttonVisible="buttonVisible"
          :moreButtonList="moreButtonList"
          ref="toolBarBtn"
        ></toolBarBtn>
      </div>
    </div>

    <div class="form-name-dv" style="margin-bottom: 10px">
      <el-tag>{{ form.productionType }}</el-tag>
      <span style="margin-left:15px;color:#6c9eff;font-weight:bold">{{ form.title }}</span>
    </div>

    <div class="settings-table-dv">
      <!-- <el-row> -->
      <!-- 重现步骤 -->
      <!-- <el-col :span="18"> -->
      <div class="contentLeftContainer">
        <div class="leftContainer" :style="{ height: cardHeight }">
          <div class="step-dv dv">
            <div class="header-dv">重现步骤</div>
            <div class="content-dv">
              <!-- <div v-if="stepList.length > 0">
                <li v-for="(item, index) of stepList" :key="index">
                  {{ item }}
                </li>
              </div> -->
              <div class="content-dv__html" :style="{ minHeight: stepContentHeight }">
                <!-- <div v-if="form.requirementDesc !== ''"> -->
                <!-- 使用组件包起来，因为需要引入富文本的css这样比较直观... -->
                <RichEditorShowDom :html="form.requirementDesc" />
                <!-- </div> -->
                <!-- <div class="null-data" v-else>
                  <el-empty description="暂无数据"></el-empty>
                </div> -->
              </div>
            </div>
          </div>
          <div class="history-dv dv" :style="{ minHeight: dvHeight }">
            <div class="header-dv">历史记录</div>
            <div class="content-dv">
              <template v-if="historyList.length > 0">
                <div class="historyItems" v-for="(item, index) of historyList" :key="index">
                  <div>
                    <span class="fontContent">{{ index + 1 }}. </span>
                    <span class="fontContent">{{ item.actionTime }} 由 </span>
                    <span class="fontKey">{{ item.actor }} </span>
                    <span class="fontContent" :style="{ color: getFontColor(item.action) }">
                      {{ item.action === '指派' ? '指派给 ' : item.action }}
                    </span>
                    <span class="fontKey">
                      {{ item.action === '指派' ? item.extra : '' }}
                    </span>
                  </div>

                  <div class="richEditor" v-if="item.comment">
                    <!-- 使用组件包起来，因为需要引入富文本的css这样比较直观... -->
                    <RichEditorShowDom :html="item.comment" />
                  </div>
                  <!-- {{ item }} -->
                </div>
              </template>
              <div class="null-data" v-else>
                <el-empty description="暂无数据"></el-empty>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </el-col> -->
      <!-- 主表信息 -->
      <!-- <el-col :span="6"> -->
      <div class="contentRightContainer">
        <div class="mainForm dv">
          <el-row>
            <el-col class="itemLabel" :span="8">模块</el-col>
            <el-col class="itemContent" :span="16">{{ form.groupName }}</el-col>
          </el-row>
          <el-row>
            <el-col class="itemLabel" :span="8">菜单</el-col>
            <el-col class="itemContent" :span="16">{{ form.vuePath }}</el-col>
          </el-row>
          <el-row>
            <el-col class="itemLabel" :span="8">当前指派</el-col>
            <el-col
              class="itemContent"
              style="color: #e08485;"
              v-if="ykDateFormat('yyyy-MM-dd', form.closedTime)"
              :span="16"
              >关闭</el-col
            >
            <el-col class="itemContent" style="color: #e2a84d;" v-else :span="16">{{ form.assignedTo }}</el-col>
          </el-row>
          <el-row>
            <el-col class="itemLabel" :span="8">提出人</el-col>
            <el-col class="itemContent" :span="16">{{ form.openedBy }}</el-col>
          </el-row>
          <el-row>
            <el-col class="itemLabel" :span="8">提出时间</el-col>
            <el-col class="itemContent" :span="16">{{ ykDateFormat('yyyy-MM-dd HH:mm:ss', form.createTime) }}</el-col>
          </el-row>
          <el-row>
            <el-col class="itemLabel" :span="8">状态</el-col>
            <el-col class="itemContent" :style="{ color: getFontColor(form.status) }" :span="16">{{
              form.status
            }}</el-col>
          </el-row>
          <el-row>
            <el-col class="itemLabel" :span="8">是否需要回滚</el-col>
            <el-col class="itemContent" :span="16"
              ><span :style="{ color: getFontColor(form.isNeedRollback) }">{{ form.isNeedRollback }}</span></el-col
            >
          </el-row>
          <el-row v-if="ykDateFormat('yyyy-MM-dd', form.deadLineTime)">
            <el-col class="itemLabel" :span="8">要求完成日期</el-col>
            <el-col class="itemContent" :span="16">{{ ykDateFormat('yyyy-MM-dd', form.deadLineTime) }}</el-col>
          </el-row>
          <el-row v-if="ykDateFormat('yyyy-MM-dd', form.closedTime)">
            <el-col class="itemLabel" :span="8">关闭日期</el-col>
            <el-col class="itemContent" :span="16">{{ ykDateFormat('yyyy-MM-dd', form.closedTime) }}</el-col>
          </el-row>
        </div>
      </div>
      <!-- </el-col>
      </el-row> -->
    </div>

    <!-- Bug操作框 -->
    <BugEditModal ref="BugEditModal" @sureUpdateForm="sureUpdateForm" :parentObj="this"></BugEditModal>

    <!-- 附件 -->
    <!-- 更改为和该问题有关联的人都可以上传文件 -->
    <BugCommitAttachment
      ref="AttachmentDrawer"
      :attachmentDisplay.sync="attachmentDisplay"
      :parentObj="this"
      :edit="
        this.id > 0 &&
          [this.form.openedBy, this.form.assignedTo].includes(this.curUserName) &&
          this.form.status !== '关闭'
      "
      :keyValue="id"
    ></BugCommitAttachment>

    <!-- 操作窗口 -->
    <OperateModal
      ref="OperateModal"
      :operateType="operateType"
      @sureHandler="sureBackOperate"
      :defaultIsNeedRollback="form.isNeedRollback"
    />
  </div>
</template>

<script>
import BugEditModal from './BugEditModal'
import BugCommitAttachment from './BugCommitAttachment.vue'
import OperateModal from './operateModal.vue'
import RichEditorShowDom from './component/richEditorShowDom.vue'
export default {
  components: {
    BugEditModal,
    BugCommitAttachment,
    OperateModal,
    RichEditorShowDom
  },
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {
          Authority: {
            edit: false,
            see: false
          }
        }
      }
    },
    joinID: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      id: 0,
      historyList: [],
      stepList: [],
      // 表单
      form: {
        ykDataProcessingID: 0,
        productionType: '',
        groupName: '',
        vuePath: '',
        title: '',
        requirementDesc: '',
        openedBy: '',
        assignedTo: '',
        status: '',
        closedTime: '',
        createTime: '',
        id: 0,
        isNeedRollback: '',
        detailList: [],
        detailListDPFiles: []
      },
      // 校验规则
      rules: {
        productionType: [
          { required: true, message: '请输入产品类型', trigger: 'change' },
          {
            min: 0,
            max: 10,
            message: '产品类型长度应在 0 到 10 个字符',
            trigger: 'change'
          }
        ],
        productionVersion: [
          { required: true, message: '请输入产品版本', trigger: 'change' },
          {
            min: 0,
            max: 16,
            message: '产品版本长度应在 0 到 16 个字符',
            trigger: 'change'
          }
        ]
      },
      // 下拉框
      ComBoxItems: {
        productionType: [],
        productionVersion: []
      },
      // 校验
      validRules: {
        groupName: [
          { required: true, message: '请输入模块名', trigger: 'change' },
          {
            min: 0,
            max: 16,
            message: '模块名长度应在 0 到 16 个字符',
            trigger: 'change'
          }
        ],
        vuePath: [
          { required: true, message: '请输入页面名', trigger: 'change' },
          {
            min: 0,
            max: 64,
            message: '页面名长度应在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        frontEngineer: [
          {
            min: 0,
            max: 5,
            message: '前端研发长度应在 0 到 5 个字符',
            trigger: 'change'
          }
        ],
        backEngineer: [
          {
            min: 0,
            max: 5,
            message: '后端研发长度应在 0 到 5 个字符',
            trigger: 'change'
          }
        ],
        techTester: [
          {
            min: 0,
            max: 5,
            message: '技术测试长度应在 0 到 5 个字符',
            trigger: 'change'
          }
        ],
        businessTester: [
          {
            min: 0,
            max: 5,
            message: '业务测试长度应在 0 到 5 个字符',
            trigger: 'change'
          }
        ],
        dMemo: [
          {
            min: 0,
            max: 64,
            message: '说明长度应在 0 到 64 个字符',
            trigger: 'change'
          }
        ]
      },
      // 动态列
      tableColumns: [],
      bodyMenus: [
        [
          {
            code: 'batchInput',
            name: '批量输入'
          },
          {
            code: 'pickMan',
            name: '选择人员'
          },
          {
            code: 'setNull',
            name: '设置为空'
          },
          {
            code: 'clear',
            name: '清空'
          }
        ]
      ],
      errIndex: [],
      // tabel工具栏
      tableToolbar: {
        buttons: [
          {
            code: 'insertOne',
            name: '新增1行',
            disabled: true
          },
          {
            code: 'insertTen',
            name: '新增10行',
            disabled: true
          }
        ]
      },
      // 右键缓存
      areas: {},
      colProperty: '',
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      specialAuthority: [],
      buttonVisible: {
        add: false,
        save: false,
        delete: false,
        update: false,
        refresh: false,
        search: false,
        sort: false,
        lock: false,
        unlock: false,
        more: false
      },
      // moreButtonList: [],
      ifAdd: false,
      // 是否绑定完成
      IfDataBindComplete: false,
      // 是否不能编辑
      dontEdit: true,
      // 是否显示附件弹窗
      attachmentDisplay: false,
      // 操作类型 => 主要用于指派、解决、关闭、激活等
      operateType: '',
      // 单据是否有操作，如果有需要刷新search界面
      IfExistModify: false
    }
  },
  created() {
    this.InitSetting()
    this.id = this.joinID ? this.joinID : 0
    this.BindText()
  },
  methods: {
    // 获取字体颜色
    getFontColor(action) {
      switch (action) {
        case '激活':
          return '#409eff'
        case '解决':
        case '已解决':
          return '#67c23a'
        case '关闭':
          return '#999999'
        // 是否会滚为是时
        case '是':
          return '#ff0000'
        default:
          return '#3c4353'
      }
    },
    // 回调函数 => 操作
    async sureBackOperate(form) {
      let flag = false
      switch (this.operateType) {
        case '指派':
          flag = await this.handleOperate(form.comment, form.extra, form.isNeedRollback)
          break
        case '激活':
          flag = await this.handleOperate(form.comment, form.extra)
          break
        case '解决':
          flag = await this.handleOperate(form.comment)
          break
      }
      if (flag) {
        this.IfExistModify = true
        if (this.operateType === '解决' && this.form.ykDataProcessingID > 0) {
          const { data: res } = await this.$http.put(
            `/Bugs/YKDataProcessing/issued/${this.form.ykDataProcessingID}`,
            {},
            {
              headers: {
                bugsManagement: true
              }
            }
          )
          if (!res.isSuccess) {
            this.$message.error(res.errorMessage)
            return false
          }
        }
        this.$message.success('操作成功!')
        this.BindText()
      }
    },
    // 操作
    async handleOperate(comment = '', extra = '', isNeedRollback = '') {
      const that = this
      const OperateBody = {
        dpBugsID: that.id,
        bugTitle: that.form.title, // 用于写入日志
        actor: that.$store.state.userInfo.userName,
        action: this.operateType,
        actionTime: that.ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date()),
        comment: comment + `${isNeedRollback === '是' ? '<p> 是否需要回滚：是 </p>' : ''}`,
        extra: extra,
        isNeedRollback
      }
      const { data: res } = await this.$http.post('/Common/DPBugs/operate', OperateBody)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 查看附件
    handleAttachment() {
      this.attachmentDisplay = true
    },
    // 修改成功返回单据
    sureUpdateForm(form) {
      this.form = form
      this.IfExistModify = true
    },
    // 获取权限
    InitSetting() {
      // 初始化为未被修改
      this.IfExistModify = false
      this.specialAuthority = this.Authority.special.map(item => item.name)
    },
    // 绑定数据
    async BindText() {
      const { data: res } = await this.$http.get('/Common/DPBugs/both', {
        params: {
          id: this.id
        }
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return
      }
      this.form = res.data
      this.historyList = res.data.detailList
    },
    // 删除单据
    delete() {
      if (this.form.ykDataProcessingID > 0) {
        this.$message.error('从用户反馈系统同步过来的问题不可删除！')
        return
      }
      this.$confirm('确定要删除本张单据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.sureDelete()
        })
        .catch(() => {})
    },
    async sureDelete() {
      const that = this
      const { data: res } = await that.$http.delete('/Common/DPBugs', {
        data: {
          id: that.id,
          BugTitle: that.form.title,
          effectCondition: that.Authority.alEffectCondition,
          empower: []
        }
      })
      if (res.isSuccess) {
        that.$message.success(that.messageConfig.del.success)
        that.IfExistModify = true
        that.back()
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    back() {
      if (this.IfExistModify) {
        this.$emit('SingleBack', true)
      } else {
        this.$emit('SingleBack', false)
      }
    },
    // 关闭问题
    async shut() {
      this.operateType = '关闭'
      let flag = await this.handleOperate()
      if (flag) {
        this.IfExistModify = true
        this.$message.success('操作成功!')
        this.BindText()
      }
    },
    // 激活问题
    activation() {
      this.operateType = '激活'
      this.$refs.OperateModal.formVisible = true
    },
    // 指派问题
    giveTo() {
      this.operateType = '指派'
      this.$refs.OperateModal.formVisible = true
    },
    // 解决问题
    solute() {
      this.operateType = '解决'
      this.$refs.OperateModal.id = this.id
      this.$refs.OperateModal.formVisible = true
    },
    edit() {
      this.openBugEditModal()
    },
    // 打开Bug填写弹窗
    openBugEditModal() {
      this.$refs.BugEditModal.isShow = !this.$refs.BugEditModal.isShow
      this.$refs.BugEditModal.operateType = 'update'
      this.$refs.BugEditModal.form = JSON.parse(JSON.stringify(this.form))
    }
  },
  computed: {
    stepContentHeight() {
      const topBottomMargin = 20
      // 表单名称div高度 + 表单名称div内边距
      const formNameDv = 30 + 15
      const isSearchForm = false
      const isToolBar = true
      // 没有查询框，只有主题内容的两段 margin
      const tableMargin = this.heightConfig.mainMargin * 2
      // 步骤card需要比历史记录高100px 好看一些
      const historySubHeight = 100
      const cardMarginOrPadding = 54 + 15

      let res = this.tableHeightComputed(tableMargin + topBottomMargin + formNameDv + 10, isSearchForm, isToolBar)
      res = (String(res).split('px')[0] / 2 - cardMarginOrPadding + historySubHeight).toFixed(2) + 'px'
      return res
    },
    dvHeight() {
      const topBottomMargin = 20
      // 表单名称div高度 + 表单名称div内边距
      const formNameDv = 30 + 15
      const isSearchForm = false
      const isToolBar = true
      // 没有查询框，只有主题内容的两段 margin
      const tableMargin = this.heightConfig.mainMargin * 2
      const historySubHeight = 105

      let res = this.tableHeightComputed(tableMargin + topBottomMargin + formNameDv + 10, isSearchForm, isToolBar)
      res = (String(res).split('px')[0] / 2 - historySubHeight).toFixed(2) + 'px'
      return res
    },
    cardHeight() {
      const topBottomMargin = 20
      // 表单名称div高度 + 表单名称div内边距
      const formNameDv = 30 + 15
      const isSearchForm = false
      const isToolBar = true
      // 没有查询框，只有主题内容的两段 margin
      const tableMargin = this.heightConfig.mainMargin * 2

      const res = this.tableHeightComputed(tableMargin + topBottomMargin + formNameDv, isSearchForm, isToolBar)
      return res
    },
    moreButtonList() {
      return [
        {
          name: '删除',
          icon: 'el-icon-delete',
          disabled:
            this.id === 0 ||
            !this.Authority.edit ||
            this.form.openedBy !== this.curUserName ||
            this.form.status === '关闭',
          event: 'delete'
        },
        {
          name: '指派',
          icon: 'el-icon-thumb',
          disabled:
            this.id === 0 ||
            this.form.status === '关闭' ||
            (this.form.assignedTo !== this.curUserName &&
              this.form.openedBy !== this.curUserName &&
              !this.specialAuthority.includes('point')),
          event: 'giveTo'
        },
        {
          name: '解决',
          icon: 'el-icon-circle-check',
          disabled:
            this.id === 0 ||
            this.form.status === '关闭' ||
            this.form.status === '已解决' ||
            this.form.assignedTo !== this.curUserName,
          event: 'solute'
        },
        {
          name: '激活',
          icon: 'el-icon-magic-stick',
          disabled: this.form.status !== '关闭' || this.form.assignedTo !== this.curUserName,
          event: 'activation'
        },
        {
          name: '关闭',
          icon: 'el-icon-switch-button',
          disabled: this.form.status === '关闭' || this.form.openedBy !== this.curUserName,
          event: 'shut'
        },
        {
          name: '编辑',
          icon: 'el-icon-edit',
          disabled: this.id === 0 || this.form.openedBy !== this.curUserName || ['关闭'].includes(this.form.status),
          event: 'edit'
        },
        {
          name: '附件',
          icon: 'el-icon-paperclip',
          disabled: false,
          event: 'handleAttachment'
        },
        {
          name: '返回',
          icon: 'iconfont fjyk-back',
          disabled: false,
          event: 'back'
        }
      ]
    },
    // 当前用户名
    curUserName() {
      return this.$store.state.userInfo.userName
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
@main-margin: 15px;
.card {
  height: calc(100vh - @header-height - (@main-margin * 2));
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 10px;
}
.buttonContainer {
  width: 100%;
}

.settings-table-dv {
  box-sizing: border-box;
  // padding: 10px 0;
  width: 100%;
  display: flex;
  overflow: auto !important;
  // &::-webkit-scrollbar {
  //   display: none !important;
  // }
  /** ************* 查找面板的滚动条整体样式 ************** **/
  &::-webkit-scrollbar {
    width: 9px; /*高宽分别对应横竖滚动条的尺寸*/
    height: auto;
  }

  /*查找面板的滚动条里面小方块*/
  &::-webkit-scrollbar-thumb {
    /* border-radius: 10px; */
    background-color: #999;
    background-color: #999;
    // background-image: -webkit-linear-gradient(
    //   45deg,
    //   rgba(255, 255, 255, 0.2) 25%,
    //   transparent 25%,
    //   transparent 50%,
    //   rgba(255, 255, 255, 0.2) 50%,
    //   rgba(255, 255, 255, 0.2) 75%,
    //   transparent 75%,
    //   transparent
    // );
    border-radius: 5px;
  }

  /*查找面板的滚动条里面轨道*/
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    background: #ededed;
    /* border-radius: 10px; */
    border-radius: 5px;
  }
}

.dv {
  width: 100%;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0px 0px 3px #e8e8e8;
  box-sizing: border-box;
  margin-top: 5px;
  overflow-y: scroll;
  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }

  .header-dv {
    font-size: 18px;
    font-weight: bold;
    padding: 15px;
    position: sticky;
    z-index: 1;
    top: 0;
    background-color: #fff;
  }

  .content-dv {
    padding: 0 15px 15px 15px;
  }
}

.null-data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.form-name-dv {
  height: 30px;
  margin-top: 15px;
  .fl(flex, flex-start, center);
}

.content-dv__html {
  border: 0px !important;
  box-sizing: border-box;
  padding: 10px 15px;
  border-radius: 5px;
  background-color: #f6f6f6;
}
.mainForm {
  box-shadow: 0 0 0 #fff !important;
  border: 0;
  width: calc(100% - 20px);
  margin-left: 10px;
  box-sizing: border-box;
  padding: 10px;
  background-color: #f9f9f9;
  .el-row {
    margin: 10px 0;
  }
  .itemLabel {
    font-size: 16px;
    color: #999999;
    text-align: right;
    box-sizing: border-box;
    padding-right: 10px;
  }
  .itemContent {
    font-size: 16px;
    color: #373737;
    box-sizing: border-box;
    padding-left: 10px;
  }
}
.historyItems {
  font-size: 14px;
  margin-top: 5px;
  .fontContent {
    color: #3c4353;
  }
  .fontKey {
    color: #333;
    font-weight: bold;
  }
  .richEditor {
    box-sizing: border-box;
    padding: 2px 5px 2px 15px;
    .ql-editor {
      margin-top: 3px;
      box-sizing: border-box;
      padding: 5px !important;
      border-radius: 5px;
      background-color: #f6f6f6;
      box-shadow: 0px 0px 3px #b7b0b0;
    }
  }
}
.contentLeftContainer {
  width: calc(100% - 400px);
}
.contentRightContainer {
  width: 400px;
  position: sticky;
  top: 0px;
}
.history-dv {
  margin-top: 10px;
}
</style>
